import React from "react";
import { Outlet } from "react-router-dom";

function Cities() {
  return <Outlet />;
}

export default Cities;
